import React from 'react'
import { faUserChart } from '@fortawesome/pro-regular-svg-icons/faUserChart'
import { faUserChart as faUserChartSolid } from '@fortawesome/pro-solid-svg-icons/faUserChart'
import { useMfe } from '@softwaredev_cegeka/microfrontend-utils/dist/react'
import MainMenuItem from 'src/components/Menu/MainMenuItem'
import useTranslations from 'src/hooks/useTranslations'
import MenuLoader from 'src/components/Menu/menus/MenuLoader'
import useUserData from 'src/hooks/useUserData'
import { reverse } from 'src/routes/config'
import useMfeTranslations from 'src/hooks/useMfeTranslations'

export default function ExampleMenu({ isOpen, parentIsCollapsed, onClick }) {
    const { t } = useTranslations('MainMenu', 'MainMenu')
    const { mfe, loadMfe } = useMfe('mfe-example', false)
    const useMfetranslationsResult = useMfeTranslations('mfe-example')
    const { t: mfeT } = useMfetranslationsResult('menu', 'menu')
    const userData = useUserData()
    return (
        <MainMenuItem
            icon={faUserChart}
            iconActive={faUserChartSolid}
            title={t('Example MFE')}
            isOpen={isOpen}
            onClick={(...args) => {
                loadMfe()
                onClick(...args)
            }}
            parentIsCollapsed={parentIsCollapsed}
        >
            {!mfe ? (
                <MenuLoader count={3} />
            ) : (
                mfe
                    .generateMenuItems?.({
                        userData,
                        basePath: reverse('example-mfe'),
                        t: mfeT,
                    })
                    ?.map(({ label, href, isActive }) => {
                        return (
                            <MainMenuItem
                                title={label}
                                to={href}
                                isActive={isActive}
                            />
                        )
                    }) ?? []
            )}
        </MainMenuItem>
    )
}
